import React from 'react'
import '../../CSS/DiscoverPage.css'
import Button from "@material-tailwind/react/Button";
import { Link } from 'react-router-dom'

const DiscoverPage = () => {
    return (
        <div className="DiscoverPage">
            <div>
            </div>
            <div>
                <h1 id='discoverHeading'>Discover Yourself</h1>
                <div className="DiscoverPageSubDiv">
                    <div className="disSubDivOne">
                        <h2>Depression</h2>
                        <small>Depression is a state of un unhappiness for a long period of time.</small>
                        <Link to='/take_test' className="">
                            <Button color="lightBlue" size="lg" ripple="light">Begin Test</Button>
                        </Link>
                    </div>

                    <div className="disSubDivTwo">
                        <h2>Depression</h2>
                        <small>Depression is a state of un unhappiness for a long period of time.</small>
                        <Link to='/take_test' className="">
                            <Button color="lightBlue" size="lg" ripple="light">Begin Test</Button>
                        </Link>
                    </div>

                    <div className="disSubDivThree">
                        <h2>Depression</h2>
                        <small>Depression is a state of un unhappiness for a long period of time.</small>
                        <Link to='/take_test' className="">
                            <Button color="lightBlue" size="lg" ripple="light">Begin Test</Button>
                        </Link>
                    </div>
                </div>   
            </div>
        </div>
    )
}

export default DiscoverPage
